import { countryStateCodes } from './config';

export function getCountryStateCodes(countryCode: string): readonly string[] | undefined {
	return countryStateCodes[countryCode]?.stateCodes;
}
